import React, { useState } from 'react'
import moment from 'moment'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
//@MUI
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'
import PulseRhythm from './PulseRhythm'
import HeartSounds from './HeartSounds'
import CarotidArtery from './CarotidArtery'
import PeripheralPulses from './PeripheralPulses'
import Oedema from './Oedema'
import ChestWall from './ChestWall'
import Jugular from './Jugular'
import AssessmentText from '../AssessmentText'

const Cardiovascular = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Stack gap={2} padding={1} component={Paper}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Cardiovascular Assessment</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <PulseRhythm
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <HeartSounds
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <CarotidArtery
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <PeripheralPulses
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Oedema moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <ChestWall
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <AssessmentText moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Cardiovascular', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default Cardiovascular
